import React from 'react';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <>
      {/* Section 2 - Identification */}
      <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-124">
        <div className="max-w-4xl mx-auto" data-id="element-125">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-126">
            <AlertTriangleIcon className="w-10 h-10 text-red-600" data-id="element-127" />
            <h2 className="text-3xl md:text-5xl font-black text-center uppercase" data-id="element-128">
              Si sos honesto con vos mismo…
            </h2>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border-2 border-gray-100 mb-8" data-id="element-129">
            <ul className="space-y-6 text-xl md:text-2xl font-bold text-gray-800" data-id="element-130">
              <li className="flex items-start gap-4" data-id="element-131">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-132" />
                <span data-id="element-133">Sabés que podrías estar vendiendo más</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-134">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-135" />
                <span data-id="element-136">Tenés algo para ofrecer… pero no pasa nada</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-137">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-138" />
                <span data-id="element-139">Publicás… pero nadie compra</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-140">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-141" />
                <span data-id="element-142">Hablás con gente… pero no cerrás</span>
              </li>
            </ul>
          </div>

          <div className="text-center bg-red-100 p-6 rounded-xl border-2 border-red-200" data-id="element-143">
            <p className="text-2xl md:text-3xl font-black text-red-800" data-id="element-144">
              Y lo peor:
              <br data-id="element-145" />
              <span className="text-gray-900 mt-2 block" data-id="element-146">
                👉 Terminás el día sintiendo que estuviste ocupado… pero no
                generaste ingresos.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Section 3 - Uncomfortable Truth */}
      <section className="py-20 px-4 bg-black text-white text-center" data-id="element-147">
        <div className="max-w-4xl mx-auto" data-id="element-148">
          <h2 className="text-5xl md:text-7xl font-black text-red-500 mb-4 uppercase tracking-tight" data-id="element-149">
            No necesitás más información.
          </h2>
          <p className="text-3xl md:text-4xl font-bold mb-12 text-gray-300" data-id="element-150">
            Ya sabés suficiente para vender.
          </p>

          <div className="bg-zinc-900 border-2 border-zinc-800 p-8 md:p-12 rounded-2xl mb-12" data-id="element-151">
            <p className="text-2xl md:text-4xl font-black text-yellow-400 mb-8" data-id="element-152">
              El problema es otro:
              <br data-id="element-153" />
              <span className="text-white text-4xl md:text-6xl mt-4 block" data-id="element-154">
                👉 No tenés un sistema.
              </span>
            </p>

            <div className="space-y-4 text-xl md:text-2xl text-gray-400 italic font-medium border-l-4 border-yellow-400 pl-6 text-left max-w-2xl mx-auto" data-id="element-155">
              <p data-id="element-156">“Demasiada información, poca ejecución”</p>
              <p data-id="element-157">“Sabés todo pero no hacés nada”</p>
            </div>
          </div>

          <div className="text-2xl md:text-4xl font-black space-y-4" data-id="element-158">
            <p data-id="element-159">Y sin sistema…</p>
            <p className="text-red-400" data-id="element-160">❌ No hay consistencia</p>
            <p className="text-red-500" data-id="element-161">❌ Sin consistencia, no hay ventas</p>
            <p className="text-red-600 text-4xl md:text-5xl mt-6" data-id="element-162">
              ❌ Sin ventas, no hay negocio
            </p>
          </div>
        </div>
      </section>
    </>;
}